import script from "./_ContactPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./_ContactPanel.vue?vue&type=script&setup=true&lang=js"

import "./_ContactPanel.vue?vue&type=style&index=0&id=4626dc01&lang=scss"

const __exports__ = script;

export default __exports__